import { render, staticRenderFns } from "./AddCustomViews.vue?vue&type=template&id=33c133e6&"
import script from "./AddCustomViews.vue?vue&type=script&lang=js&"
export * from "./AddCustomViews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33c133e6')) {
      api.createRecord('33c133e6', component.options)
    } else {
      api.reload('33c133e6', component.options)
    }
    module.hot.accept("./AddCustomViews.vue?vue&type=template&id=33c133e6&", function () {
      api.rerender('33c133e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/customviews/AddCustomViews.vue"
export default component.exports